export const socialsData = {
  github: "https://github.com/OfficialSiddharthBisht",
  // facebook: 'https://www.facebook.com/',
  linkedIn: "https://www.linkedin.com/in/siddharth-bisht-57084b198/",
  // instagram: 'https://www.instagram.com/renu.kote',
  // codepen: 'https://codepen.io/',
  // twitter: 'https://twitter.com/KoteRenu',
  // reddit: 'https://www.reddit.com/user/',
  medium: "https://medium.com/@officialsiddharthbisht",
  // stackOverflow: 'https://stackoverflow.com/users/',
  // gitlab: 'https://gitlab.com/',
  // youtube: 'https://youtube.com/',
};
